import { useEffect, useState } from "react";

export default function WhatsAppFloating() {
  const [mounted, setMounted] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setMounted(true);
    const onScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!mounted) return null;

  return (
    <a
      href="https://wa.me/34627213347?text=Hola%2C%20me%20interesa%20info%20sobre%20vuestros%20servicios"
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-4 right-4 z-[9998] w-14 h-14 md:w-16 md:h-16 bg-whatsapp rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all md:bottom-6 md:right-6 ${
        scrolled ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      } hidden md:flex`}
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-2xl"></i>
    </a>
  );
}